import { Button, type ButtonVariant } from "@circle-react-uikit/Button";

interface ButtonWithMarginProps {
  children: React.ReactNode;
  variant?: ButtonVariant;
}

export const ButtonWithMargin = ({
  children,
  variant = "primary",
}: ButtonWithMarginProps) => (
  <div className="mb-6">
    <Button full extraLarge variant={variant}>
      {children}
    </Button>
  </div>
);
